IREP.video = (function() {
    "use strict";

    var defaultOptions = {
        containerId: "vidContainer",
        width: 640,
        height: 360,
        paxUID: IREP.options.currentUID
    };

    var init = function(videoOptions) {
        var options = $.extend({}, defaultOptions, videoOptions);
        initPlayer(options);
    };

    var initPlayer = function(options) {
        var flashVars = {
            CultureCode: IREP.options.user.cultureCode,
            CaptionsURL: "",
            PostBackURL: "/_layouts/PostStatsURL.aspx",
            VideoURL: options.videoUrl,
            VideoUID: options.videoUID,
            ImageURL: "",
            ParticipantUID: options.paxUID,
            ShowStartButton: 1,
            VideoSource: 0,
            AutoPlayVideo: 1,
        };

        var params = {};
        var attributes = {};
        swfobject.embedSWF("https://retailedge.intel.com/ww/swf/mt40player.swf", options.containerId, options.width, options.height, '9.0.0', "", flashVars, params, attributes);
        $("#vidPlayerContainer").show();
    };

    return {
        init: init
    };
})();